<template>
  <div class="pm-dialog-head-count">

    <div class="flex justify-center" style="margin-bottom:1rem;">
      <div class="flex items-center justify-center pm-dialog-head-count-input" :class="[ headCountStrings.length > 0 ? 'input-any' : 'input-null' ]">
        <div style="margin:0.4rem;">
          <span v-for="( headCount, index ) in headCountStrings" :key="index">
            <span :style="{color:colorCode(colorIds[index])}" style="margin:0 0.1rem;">{{ headCount }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="flex justify-center">
      <div v-for="(color,index) in colorsList" :key="index" style="margin:0.2rem;" @mousedown="onKeyDownColor(color.id)" >
        <vs-chip style="border-radius:5px;" :style="'border: 1px solid #888;'" :color="selectedColorId === color.id ? color.value.toUpperCase() === '#F2F2F2' ? 'black' : color.value : '#f2f2f2'">
           <feather-icon icon="Edit2Icon" svgClasses="h-6 w-6" :style="{ color: selectedColorId === color.id ? '#F2F2F2' : color.value.toUpperCase() === '#F2F2F2' ? 'black' : color.value}" />
        </vs-chip>
      </div>
    </div>
    <div class="flex justify-center">
      <div class="vs-row flex justify-start" style="width:80%;">
        <div class="vs-col candidate-list"  v-for="(master,index) in masterList" :key="index" style="margin:0.2rem;" @mousedown="onKeyDown(master.value)" >
          <vs-chip :style="inputColor" class="pm-input-key">
            {{ master.value }}
          </vs-chip>
        </div>
      </div>
    </div>

    <div class="flex justify-center">
      <div class="flex justify-end" style="width:80%;" @mousedown="onClear">
        <vs-chip
          class="pm-input-key clear-button"
        >クリア</vs-chip>
      </div>
    </div>
    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
        v-shortkey="{save: ['enter'], saveWithUpdateTime: ['shift', 'enter']}" @shortkey="callKeyActions"
      >
        保存
      </vs-button>
      <vs-button
        v-if="!isImportEditMode && !isInsertOneMode"
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import Vue from "vue";
// Editでは修正
// const { mapActions, mapState, mapGetters } = createNamespacedHelpers("portMasterDestinationWork");
const { mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
    isImportEditMode: { type: Boolean,  default: false },
    isInsertOneMode:  { type: Boolean,  default: false },
  },
  data() {
    return {
      headCountStrings: [],
      colorIds: [],
      selectedColorId: 0,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      return this.masterMap['head_count'];
    },
    enableSave() {
      return true; // ( this.headCountStrings && this.headCountStrings.length > 0 );
    },
    colorsList() {
      return this.masterMap['head_count_colors'];
    },
    inputColor() {
      let colroHex = '#111';
      let colorObj =  this.colorsList.find(x => x.id === this.selectedColorId && this.selectedColorId !== 0);
      Vue.$log.debug("colorObj",colorObj);
      if ( colorObj ) {
        colroHex = colorObj.value;
      }
      return {'color':colroHex};
    },
  },
  methods: {
    initData() {
      this.headCountStrings = this.valueMap && this.valueMap.value ? JSON.parse(JSON.stringify(this.valueMap.value)) : [];
      this.colorIds = this.valueMap && this.valueMap.color_id ? JSON.parse(JSON.stringify(this.valueMap.color_id)) : [];
      this.selectedColorId = 0;
    },
    onKeyDown(key){
      this.headCountStrings.push(key);
      this.colorIds.push(this.selectedColorId);
    },
    onClear() {
      this.headCountStrings = [];
      this.colorIds = [];
      this.selectedColorId = 0;
    },
    callKeyActions(event) {
      switch (event.srcKey) {
      case 'save':
        if (this.enableSave) this.onSubmit(false, true)
        break
      case 'saveWithUpdateTime':
        if (this.enableSave) this.onSubmit(true, true)
        break
      }
    },
    onSubmit(isUpdateTimeStamp, toNextColumn = false) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      if (toNextColumn) mode.push("toNextColumn")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey + "#value"   ] = this.headCountStrings;
      updateKeyValueMap[this.columnKey + "#color_id"] = this.colorIds.map(element => element ? element : -1);
      this.$emit('updateValue',this.taskId, updateKeyValueMap, mode, this.columnKey);
    },
    onKeyDownColor(colorCode) {
      this.selectedColorId = colorCode;
    },
    colorCode(colorId){
      let colorObj = this.colorsList.find(color => color.id === colorId);
      return colorObj ? ( colorObj.value && colorObj.value.toUpperCase() === '#F2F2F2' ? '#09151c' : colorObj.value ) : null;
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-head-count {
  .pm-dialog-head-count-input {
    width:10rem;
    height:3rem;
  }
  .input-any {
    background-color: $pm-white;
    border: 1px solid $pm-blue;
  }
  .input-null {
    background-color: $pm-light-gray;
    border: none;
  }
  .candidate-list {
    margin:0.2rem;
    padding: 0rem;
    .con-vs-chip {
      border-radius:6px;
      height:3rem;
      font-size: 120%;
      min-width: 3rem;
    }
  }
  .pm-input-key {
    background-color: $pm-paper-white;
    border: 1px solid $pm-gray;
    color: $pm-black;
    cursor: pointer;
    &:hover {
      background-color: $pm-blue;
      border: 1px solid $pm-blue;
      color: $pm-white !important;
    }
  }
  .clear-button {
    margin-top: 0.4rem;
    border-radius: 5px;
    font-size: 120%;
    min-width:2rem;
    height: 2.2rem;
    width: 8rem;
  }
  .save-button {
    margin: 1rem !important;
    width: 30%;
  }
}
</style>

